module.exports = __webpack_public_path__ + "static/img/Bachelor_010664.25da33a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010664.jpg
// module id = 209
// module chunks = 0